import { ConfigurationInterface } from '@e3labs/isa-data-dictionary';
import {
  SET_LOADING_DATA,
  SET_LOADING_SEND,
  GET_REQUEST,
  GET_SUCCESS,
  SAVE_REQUEST,
  SAVE_SUCCESS,
  RELOAD_REQUEST,
  RELOAD_SUCCESS
} from './configuration-constants';

export const setLoadingData = (loading: Boolean) => {
  return {
    type: SET_LOADING_DATA,
    loading
  };
};

export const setLoadingSend = (loading: Boolean) => {
  return {
    type: SET_LOADING_SEND,
    loading
  };
};

export const getRequest = (reload?: boolean) => {
  return {
    type: GET_REQUEST,
    reload
  };
};

export const getSuccess = (payload: any) => {
  return {
    type: GET_SUCCESS,
    payload
  };
};

export const saveRequest = (payload: ConfigurationInterface, files?: any, callbackUpload?: Function) => {
  return {
    type: SAVE_REQUEST,
    payload,
    files,
    callbackUpload
  };
};

export const saveSuccess = () => {
  return {
    type: SAVE_SUCCESS
  };
};

export const reloadRequest = () => {
  return {
    type: RELOAD_REQUEST
  };
};

export const reloadSuccess = (payload: ConfigurationInterface) => {
  return {
    type: RELOAD_SUCCESS,
    payload
  };
};
